import PropTypes from "prop-types";
import React from "react";

import { inputPropTypes } from "@swa-ui/core";
import { TextFormField } from "@swa-ui/form";
import i18n from "@swa-ui/locale";

import {
  APARTMENT_SUITE_MAX_LENGTH,
  APARTMENT_SUITE_SCHEMA_FIELD_NAME,
} from "./ApartmentSuiteFormField.schema";

/**
 * ApartmentSuiteFormField facilitates the input of a Apt/Suite.
 */

export const ApartmentSuiteFormField = (props) => {
  const {
    componentProps,
    disabled,
    description,
    label = i18n("ApartmentSuiteFormField__LABEL"),
    name = APARTMENT_SUITE_SCHEMA_FIELD_NAME,
  } = props;

  return <TextFormField {...getTextFormFieldProps()} />;

  function getTextFormFieldProps() {
    return {
      componentProps: {
        "aria-label": i18n("ApartmentSuiteFormField__ARIA"),
        maxLength: APARTMENT_SUITE_MAX_LENGTH,
        ...componentProps,
      },
      description,
      disabled,
      label,
      name,
    };
  }
};

export const apartmentSuiteFormFieldPropTypes = {
  /** Component props for input component. */
  componentProps: PropTypes.shape(inputPropTypes),

  /** Indicates whether the field is disabled. */
  disabled: PropTypes.bool,

  /** Content above the form field, used to identify the form field. */
  label: PropTypes.string,

  /** Form field name used in schema validation and service call payload. */
  name: PropTypes.string,
};

ApartmentSuiteFormField.propTypes = apartmentSuiteFormFieldPropTypes;
